import React from "react";
import { Icon, Phone, CheckCircle } from "./icons";
import { Photo } from "./photo";

export const Header = ({ data, brand, vehicle }) => {
  if (!data) return <header id="accueil" className="hero hero--loading" />;

  return (
    <header id="accueil" className="hero">
      <Photo
        src={data.image}
        alt="Renault Trafic SAFE MOUV devant la Tour Eiffel"
        label="Photo véhicule"
        className="hero-photo"
      />
      <div className="hero-veil" />

      <div className="container hero-inner">
        <div className="hero-copy">
          <p className="hero-eyebrow">{data.eyebrow}</p>
          <h1 className="hero-title">
            {data.title}
            <br />
            {data.titleAccent}
          </h1>
          <p className="hero-text">
            {data.paragraph.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>

          <div className="hero-actions">
            <a href="#reservation" className="btn btn-primary">
              <Icon name="calendar" size={17} />
              Réserver en ligne
            </a>
            <a href="#contact" className="btn btn-ghost">
              Demander un devis
            </a>
            <a href={`tel:${brand?.phoneLink || ""}`} className="btn btn-ghost">
              <Phone size={16} />
              Appeler
            </a>
          </div>
        </div>

        {vehicle && (
          <a href="#vehicule" className="hero-vehicle-card">
            <p className="hero-vehicle-kicker">{vehicle.title}</p>
            <p className="hero-vehicle-sub">{vehicle.subtitle}</p>
            <ul>
              {vehicle.features.map((f) => (
                <li key={f}>
                  <CheckCircle size={13} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </a>
        )}
      </div>

      <div className="hero-strip">
        <div className="container hero-strip-inner">
          {data.highlights.map((h) => (
            <div className="hero-chip" key={h.line1 + h.line2}>
              <Icon name={h.icon} size={20} />
              <span>
                {h.line1}
                <br />
                {h.line2}
              </span>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
